module.exports = __webpack_public_path__ + "static/media/image-card-1.fe090911.png";